import React from 'react';
import { IconButton, makeStyles, colors } from '@material-ui/core';
import { Edit, Cancel } from '@material-ui/icons';

import DeleteMenu from 'components/menu/DeleteMenu';

const useStyles = makeStyles({
  deleteButton: {
    color: colors.red[900],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
  editButton: {
    color: colors.red[400],
    '&:hover': {
      backgroundColor: colors.red[100],
    },
  },
});

const EditDeleteButtons = ({
  message,
  onEditButtonClick,
  onRemoveButtonClick,
}) => {
  const classes = useStyles();

  return (
    <DeleteMenu
      message={message}
      onDeleteButtonClick={onRemoveButtonClick}
      renderButton={(_onDeleteButtonClick) => (
        <div>
          <IconButton
            onClick={onEditButtonClick}
            className={classes.editButton}
          >
            <Edit></Edit>
          </IconButton>

          <IconButton
            onClick={_onDeleteButtonClick}
            className={classes.deleteButton}
          >
            <Cancel></Cancel>
          </IconButton>
        </div>
      )}
    ></DeleteMenu>
  );
};

export default EditDeleteButtons;
